"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../../utils"),
    reflectURLAttribute = _require.reflectURLAttribute;

var HTMLEmbedElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLEmbedElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLEmbedElementImpl);

  function HTMLEmbedElementImpl() {
    _classCallCheck(this, HTMLEmbedElementImpl);

    return _super.apply(this, arguments);
  }

  _createClass(HTMLEmbedElementImpl, [{
    key: "src",
    get: function get() {
      return reflectURLAttribute(this, "src");
    },
    set: function set(value) {
      this.setAttributeNS(null, "src", value);
    }
  }]);

  return HTMLEmbedElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLEmbedElementImpl
};